import React, { Component } from 'react';
import { object, shape, string } from 'prop-types';
import { connect } from 'react-redux';

import NoteSlatViews from './views';


class NoteSlat extends Component {
  render() {
    const { isNoteEditorOpen, position, selectedHighlight } = this.props;

    const styles = {
      top: position.y,
      left: position.x,
      backgroundColor: selectedHighlight.color,
      borderColor: selectedHighlight.darkColor
    };

    const viewProps = {
      isNoteEditorOpen,
      styles
    };

    return <NoteSlatViews { ...viewProps } />;
  }
}

NoteSlat.propTypes = {
  position: object,
  selectedHighlight: shape({
    color: string.isRequired,
    label: string.isRequired,
    markerId: string.isRequired,
    id: string,
    noteText: string,
    lastModifiedAt: string
  })
}

function mapStateToProps(state) {
  const { annotation, noteslat, selectedHighlight } = state;
  return {
    isNoteEditorOpen: noteslat.isNoteEditorOpen,
    position: annotation.position,
    selectedHighlight
  };
}


export default connect(mapStateToProps)(NoteSlat);
